export enum LocalPlayerModes {
  singleMultiplayer = "singleMultiplayer",
  multiplayer = "multiplayer",
  couchCoOp = "couchCoOp",
}

export enum OnlinePlayerModes {
  onlineSinglePlayer = "onlineSinglePlayer",
  onlineMultiplayer = "onlineMultiplayer",
  onlineCoOp = "onlineCoOp",
}
